import { useContext } from "react"
import { EditorToolbarButton, EditorToolbarTray } from "./EditorToolbarUI";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const EditorHistoryTray = ({context}) => {
    const { editor, editorState } = useContext(context);

    return (
        <EditorToolbarTray>
            <EditorToolbarButton
                icon={<MaterialIcon name='undo' weight={300}/>}
                disabled={!editorState.canUndo}
                onClick={() => editor.commands.undo()}
            />

            <EditorToolbarButton
                icon={<MaterialIcon name='redo' weight={300}/>}
                disabled={!editorState.canRedo}
                onClick={() => editor.commands.redo()}
            />
        </EditorToolbarTray>
    )
}